
















import { defineComponent, reactive, SetupContext } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { getEntityStorePath } from '@/store/entityModules/utils';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import { useStore } from '@/components/composables/useStore';

const Component = defineComponent({
  name: 'ProductCategoryOptionTable',

  components: {
    EntityTable,
  },

  setup(props: any, { root: { $router } }: SetupContext) {
    const store: Store<RootState> = useStore();
    const entityType = EntityType.PRODUCT_CATEGORY_OPTION;
    const storePath = getEntityStorePath(entityType);

    store.dispatch(`${storePath}/setQuerySorting`, {
      sortBy: 'from',
      descending: 0,
    });

    const state = reactive({
      headers: [
        { text: 'Title', value: 'title', sortable: true },
        { text: 'Enable by default', value: 'value', sortable: false },
        { text: 'Price per pair', value: 'pricePerPair', sortable: false },
        { text: 'Override in Product', value: 'overrideInProduct', sortable: false },
        { text: 'Min Quantity', value: 'minQuantity', sortable: false },
        { text: 'Min Size Quantity', value: 'minSizeQuantity', sortable: false },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
      selectedTab: 2,
    });

    function reditectToAttributes() {
      $router.push('attributes');
    }

    return {
      entityType,
      state,
      reditectToAttributes,
    };
  },
});
export default Component;
